export class OrderConstants {
  public static readonly CreatingUrgencyId = 1;

  public static readonly MaxFileSize = 5000000;
  public static readonly SupportedFileFormat = [
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.pdf',
    '.jpg',
    '.jpeg',
    '.gif',
    '.png',
    '.txt',
    '.msg',
    '.cer',
    '.eml',
    '.rdp',
    '.tar',
    '.xz',
    '.gz',
    '.zip',
    '.7z',
  ];

  public static readonly Resource = class {
    public static readonly UserWebSD = class {
      public static readonly Id = 81;
      public static readonly Value = 'Пользователь Web SD';
    };
  };

  public static readonly AllowedValuesOfEvaluation = [1, 2, 3];
}
